import type { SearchableField } from "@salon/types";

export const SALON_CONFIG_SEARCH: SearchableField[] = [
  {
    id: "salon.appointment_worker_assignment_enabled",
    sectionId: "salon-config",
    labelKey: "search.salonConfig.workerAssignment.label",
    descriptionKey: "search.salonConfig.workerAssignment.description",
    keywordsKey: "search.salonConfig.workerAssignment.keywords",
    anchor: "field-salon-worker-assignment",
  },
  {
    id: "salon.outcome_tracking_enabled",
    sectionId: "salon-config",
    labelKey: "search.salonConfig.outcomeTracking.label",
    descriptionKey: "search.salonConfig.outcomeTracking.description",
    keywordsKey: "search.salonConfig.outcomeTracking.keywords",
    anchor: "field-salon-outcome-tracking",
  },
  {
    id: "salon.outcome_tracking_mode",
    sectionId: "salon-config",
    labelKey: "search.salonConfig.trackingMode.label",
    descriptionKey: "search.salonConfig.trackingMode.description",
    keywordsKey: "search.salonConfig.trackingMode.keywords",
    anchor: "field-salon-tracking-mode",
  },
];
